let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eOt8B")).then(() => parcelRequire('864s3'));